<template>
  <div v-if="referralNumber">
    <match-media>
      <template v-for="(section, key) in sectionsWithDueTotal">
        <div :key="key" class="mt-3">
          <b-skeleton-wrapper :loading="loading">
            <template #loading>
              <b-card>
                <b-row>
                  <b-col>
                    <b-skeleton width="85%" />
                    <b-skeleton width="55%" />
                  </b-col>
                  <b-col>
                    <b-skeleton width="70%" />
                    <b-skeleton width="55%" />
                  </b-col>
                  <b-col>
                    <b-skeleton width="85%" />
                    <b-skeleton width="55%" />
                  </b-col>
                  <b-col>
                    <b-skeleton width="70%" />
                    <b-skeleton width="55%" />
                  </b-col>
                  <b-col>
                    <b-skeleton type="button" width="100%" />
                  </b-col>
                </b-row>
              </b-card>
            </template>

            <template v-for="(item, i) in section.items">
              <b-card
                :key="i"
                class="bg-light-gray border-0"
                :class="{ 'mt-2': i > 0 }"
              >
                <b-row>
                  <template
                    v-if="
                      key === INTERVENTION_TYPES.REQUEST_FOR_COMPENSATORY_HOURS
                    "
                  >
                    <b-col cols="12" md>
                      <dl class="m-0 text-center">
                        <dd class="m-0">
                          <custom-balloon
                            :hex-color="getStatusColor(item.statusId)"
                            class="border-none text-center font-15"
                            :text="item.status"
                            dot
                          />
                        </dd>
                        <dd class="m-0">{{ item.requestNumber }}</dd>
                      </dl>
                    </b-col>
                  </template>

                  <b-col
                    :class="{
                      'mt-2 mt-md-0':
                        key ===
                        INTERVENTION_TYPES.REQUEST_FOR_COMPENSATORY_HOURS
                    }"
                    cols="12"
                    md
                  >
                    <dl class="m-0 text-md-center">
                      <dd class="m-0 text-muted small">Año Académico:</dd>
                      <dd class="m-0">{{ item.academicYearDesc }}</dd>
                    </dl>
                  </b-col>
                  <b-col class="mt-2 mt-md-0" cols="12" md>
                    <dl class="m-0 text-md-center">
                      <dd class="m-0 text-muted small">
                        Intervenciones Adeudadas:
                      </dd>
                      <dd class="m-0">{{ item.interventionsDue }}</dd>
                    </dl>
                  </b-col>
                  <b-col class="mt-2 mt-md-0" cols="12" md>
                    <dl class="m-0 text-md-center">
                      <dd class="m-0 text-muted small">
                        Intervenciones Ofrecidas:
                      </dd>
                      <dd class="m-0">{{ item.interventionsOffered }}</dd>
                    </dl>
                  </b-col>
                  <b-col class="mt-2 mt-md-0" cols="12" md>
                    <dl class="m-0 text-md-center">
                      <dd class="m-0 text-muted small">Balance:</dd>
                      <dd class="m-0">{{ isRejectedOrCompletedStatus(item) ? 0 : item.interventionsDueTotal }}</dd>
                    </dl>
                  </b-col>
                  <b-col class="mt-2 mt-md-0 text-md-right" cols="12" md>
                    <template
                      v-if="
                        key ===
                          INTERVENTION_TYPES.REQUEST_FOR_COMPENSATORY_HOURS
                      "
                    >
                      <dropdown :data-item="{ item, i }" :items="actionItems" />
                    </template>
                  </b-col>
                </b-row>
              </b-card>
            </template>

            <CustomResultNotFound
              v-if="section.items && section.items.length === 0"
              :text="`No posee registros de ${sections[key].title}`"
            />
          </b-skeleton-wrapper>
        </div>
      </template>
    </match-media>
  </div>
</template>

<script>
import { MatchMedia } from "vue-component-media-queries";
import CustomResultNotFound from "custom-result-not-found";
import compensatoryServiceStatus from "@/utils/constants/compensatoryServiceStatus.js";
import compensatoryRequestStatus from '@/utils/constants/compensatoryRequestStatus.js';
import { providerApi } from "@/core/api";
import {
  CustomBalloonLight as CustomBalloon,
} from '@/components/common';
import Dropdown from "dropdown";

const INTERVENTION_TYPES = {
  REQUEST_FOR_COMPENSATORY_HOURS: "REQUEST_FOR_COMPENSATORY_HOURS"
};

export default {
  name: "InterventionsDue",
  components: { MatchMedia, CustomResultNotFound, CustomBalloon, Dropdown },
  props: {
    referralNumber: { type: String, default: null, required: true },
    studentName: { type: String, default: null, required: false },
    disciplineName: { type: String, default: null, required: false },
    serviceSpecialistName: { type: String, default: null, required: false },
    studentSieId: { type: Number, default: null, required: true },
    disciplineTypeId: { type: Number, default: null, required: true },
    academicYearId: { type: Number, default: null, required: true }
  },
  data: () => ({
    loading: false,
    sections: {
      [INTERVENTION_TYPES.REQUEST_FOR_COMPENSATORY_HOURS]: {
        title: "Solicitud de horas compensatorias",
        items: []
      }
    },
    INTERVENTION_TYPES
  }),
  computed: {
    actionItems() {
      return [
        {
          name: "Ver Solicitud",
          label: "Ver Solicitud",
          icon: "fas fa-file-invoice color-primary-1",
          click: ({ item }) => {
            this.onRequestNavigation(item);
          },
          visible: this.viewMenuEditAction
        },
        {
          name: "Análisis de Cierre",
          label: "Análisis de Cierre",
          icon: "fas fa-clipboard-list-check color-primary-1",
          click: ({ item }) => {
            this.$router.push({
              name: "ClosingAnalysis",
              params: { id: item.detail.requestId }
            });
          },
          visible: ({ item }) => {
            return (
              item.detail.isReposition &&
              (item.statusId == compensatoryServiceStatus.Aprobado ||
                item.statusId == compensatoryServiceStatus.AprobadoModificado ||
                item.statusId ==
                  compensatoryServiceStatus.CompletadoPendienteAprobacion ||
                item.statusId == compensatoryServiceStatus.ProcesoCompletado ||
                item.statusId == compensatoryServiceStatus.DevueltoAProveedor)
            );
          }
        }
      ];
    },
    sectionsWithDueTotal() {
      return Object.entries(this.sections).reduce(
        (sum, [key, x]) => ({
          ...sum,
          [key]: {
            ...x,
            items: x.items.map(y => ({
              ...y
            }))
          }
        }),
        {}
      );
    },
    flattenedSectionsWithDueTotal() {
      return Object.values(this.sectionsWithDueTotal)
        .map(x => x.items)
        .flat();
    },
    interventionsSum() {
      return this.flattenedSectionsWithDueTotal.reduce(
        (sum, { interventionsDue }) => +interventionsDue + sum,
        0
      );
    },
    interventionsOfferedSum() {
      return this.flattenedSectionsWithDueTotal.reduce(
        (sum, { interventionsOffered }) => +interventionsOffered + sum,
        0
      );
    },
    interventionsTotalSum() {
      return this.flattenedSectionsWithDueTotal.reduce(
        (sum, { interventionsDueTotal }) => +interventionsDueTotal + sum,
        0
      );
    },
    getStatusColor() {
      return (statusId) => {
        let color = '#f8ca80';
        switch (statusId) {
          case compensatoryRequestStatus.Approved:
          case compensatoryRequestStatus.RequestCompleted:
          case compensatoryRequestStatus.ProcessCompleted:
            color = '#b7e3b6';
            break;
          case compensatoryRequestStatus.RequestRejected:
            color = '#d5b89a';
            break;
          case compensatoryRequestStatus.ReturnedToSupplier:
            color = '#efcbc9';
            break;
          case compensatoryRequestStatus.ApprovedModified:
          case compensatoryRequestStatus.Denied:
          case compensatoryRequestStatus.ExcludedServiceHigh:
          case compensatoryRequestStatus.ExcludedGraduated:
          case compensatoryRequestStatus.ExcludedByStrategy:
            color = '#ebcb8b';
            break;
          case compensatoryRequestStatus.New:
            color = '#b5c3bc';
            break;

          default:
            break;
        }
        return color;
      };
    },
    isRejectedOrCompletedStatus() {
      return (item) => {
        const rejectedBalanceStatuses = [
          compensatoryRequestStatus.RequestRejected,
          compensatoryRequestStatus.ExcludedByStrategy,
          compensatoryRequestStatus.ExcludedGraduated,
          compensatoryRequestStatus.ExcludedServiceHigh,
          compensatoryRequestStatus.RequestCompleted,
        ];

        return rejectedBalanceStatuses.includes(item.statusId);
      };
    },
  },
  async created() {
    await this.getInterventionsDue();
  },
  methods: {
    calcInterventionsDueTotal(a, b) {
      return Math.abs(+a - +b);
    },
    async onRequestNavigation(item) {
      const request = item.detail;
      this.$router.push({
        name: "CompensatoryRequest",
        query: {
          isReposition: request.isReposition
        },
        params: {
          ...request,
          ...this.$route.params,
          readOnly: item.statusId !== compensatoryServiceStatus.Nuevo,
          from: "/referral/search"
        }
      });
    },
    async getInterventionsDue() {
      this.loading = true;
      try {
        const { data } = await providerApi.get(
          `/api/compensatoryrequest/interventionsDue/${this.studentSieId}/${this.disciplineTypeId}`
        );
        if (data) {
          const { compensatoryHourRequests } = data;
          this.sections[
            INTERVENTION_TYPES.REQUEST_FOR_COMPENSATORY_HOURS
          ].items =
            compensatoryHourRequests != null
              ? compensatoryHourRequests.map(data => {
                  return {
                    ...data,
                    detail: {
                      ...data.detail,
                      studentName: this.studentName,
                      disciplineName: this.disciplineName,
                      serviceSpecialistName: this.serviceSpecialistName
                    }
                  };
                })
              : [];
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style scoped>
.primary-10 {
  background-color: #d5b89a;
}

.primary-11 {
  background-color: #f8ea80;
}

.primary-12 {
  background-color: #ddb3d7;
}

.primary-13 {
  background-color: #f8ca80;
}

.primary-15 {
  background-color: #a4e5b2;
}

.primary-16 {
  background-color: #fcc9c8;
}
</style>
